import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Dispositivo } from 'app/models/dispositivo.model';
import { AppFilter } from 'app/models/app-filter.model';
import { AbDispositivoHub } from 'app/abstract/full-pages/hub/dispositivo-hub.abstract';

@Injectable({ providedIn: 'root' })
export class DispositivoHubService extends AbDispositivoHub {

  public endpoint: string = "dispositivos/hub/";

  public mostrarButtonAdicionar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllFabricantesControleAcessoAtivos() {
    return this.get('fabricantes/controle_acesso/ativos/');
  }

  public getAllModelosFabricanteControlaAcesso(fabricanteId: number) {
    return this.get(`modelos/controlaAcesso/${fabricanteId}`);
  }

  public salvar(dispositivo: Dispositivo): Observable<any> {
    return this.save(this.endpoint, dispositivo);
  }

  public desativar(id: number) {
    return this.delete(`${this.endpoint}desativar/`, id);
  }

  public getAllDispositivos(filter: AppFilter): Observable<any> {
    return this.get(`${this.endpoint}ativos/${filter.encode()}`);
  }

  public testarConexao(dispositivo: Dispositivo) {
    return this.http.post(this.url + `${this.endpoint}testarConexao/`, dispositivo);
  }

  public testarConexaoStatus(dispositivo: Dispositivo) {
    return this.http.post(this.url + `${this.endpoint}testarConexao/status`, dispositivo);
  }

  public getDispositivosControlaAcesso() {
    return this.get(`${this.endpoint}controlaAcesso`);
  }

  public getAllDispositivosColeta(tipoColeta: any): Observable<any> {
    return this.get(`${this.endpoint}coleta/ativos/${tipoColeta}`);
  }

  public getLogSincronizacao(filter: AppFilter): Observable<any> {
    return this.get(`log_sincronismo/filter/${filter.encode()}`)
  }

  public getLogEventos(filter: AppFilter): Observable<any> {
    return this.get(`${this.endpoint}log_eventos/${filter.encode()}`);
  }
}
